import ActionTypes from '@constants/action_types.js'
import EmbedKeyAPI from '@api/embed_key_web_api.js'
import { handleLoadEmbedKeySuccess, handleLoadEmbedKeyError } from './embed_key_server_actions.js'

export function receiveEmbedKeys(embedKeys) {
  return {
    type: ActionTypes.RECEIVE_EMBED_KEYS,
    payload: embedKeys,
  }
}

export function loadEmbedKey(timelineId) {
  return (dispatch, getState) => {
    dispatch(loadStart())
    EmbedKeyAPI.fetchEmbedKey(timelineId).then(
      res => {
        dispatch(handleLoadEmbedKeySuccess(res))
      },
      err => {
        dispatch(handleLoadEmbedKeyError(err))
      }
    )
  }
}

function loadStart() {
  return {
    type: ActionTypes.LOAD_EMBED_KEY_START,
  }
}
